import { render, staticRenderFns } from "./Smsacceptback.vue?vue&type=template&id=20ceae6c"
import script from "./Smsacceptback.vue?vue&type=script&lang=js"
export * from "./Smsacceptback.vue?vue&type=script&lang=js"
import style0 from "./Smsacceptback.vue?vue&type=style&index=0&id=20ceae6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports